import { Link } from 'react-router-dom';

const stats = [
  { value: '6,000+', label: '漫画资源' },
  { value: '100万+', label: '日活用户' },
  { value: '8大', label: '题材分类' },
  { value: '每日', label: '持续更新' },
];

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20gradient%20composition%20with%20warm%20orange%20and%20deep%20teal%20flowing%20shapes%2C%20soft%20layered%20textures%20inspired%20by%20Korean%20traditional%20ink%20painting%20meets%20modern%20digital%20art%2C%20elegant%20flowing%20lines%20and%20geometric%20patterns%20blending%20seamlessly%2C%20dark%20moody%20background%20with%20vibrant%20color%20accents%2C%20cinematic%20atmosphere%2C%20high%20contrast%2C%20luxurious%20art%20print%20quality&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="韩漫天堂 - 免费韩国漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="韩漫天堂 - 免费韩国漫画在线阅读平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-4xl" data-product-shop>
          <h1
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            韩漫天堂 - 免费韩国漫画
            <br />
            <span className="text-primary-400">在线阅读平台</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            汇集海量韩国漫画资源，无需注册，即点即看。涵盖恋爱、奇幻、动作、悬疑等多种题材，
            每日更新，多设备兼容，为您带来极致阅读体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              立即开始阅读
            </Link>
            <Link
              to="/#featured"
              className="px-8 py-3 rounded-full bg-white/15 text-white font-medium text-sm hover:bg-white/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
            >
              热门推荐
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: 'var(--font-heading)' }}>
                  {stat.value}
                </div>
                <div className="text-sm text-white/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}